module.exports = __webpack_public_path__ + "img/svg/background-error-warriors.d4e89f6dadfb36dbf961f036379aa238.svg";